<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import PubSub from "pubsub-js";
    export default {
        name: "ErrorLog",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'url',
                        placeholder: '请求地址',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'errorLog:add',
                    update: 'errorLog:update',
                    delete: 'errorLog:delete',
                    deleteBatch: 'errorLog:deleteBatch'
                },
                url: {
                    get: '/errorLog/listByCondition',
                    //add: '/operationLog/add',
                    //update: '/operationLog/update',
                    //delete: '/operationLog/delete/',
                    //delete_batch: '/operationLog/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'url',
                    label: '请求地址',
                    show: true,
                    width: '',
                }, {
                    field: 'message',
                    label: '错误信息',
                    show: true,
                    width: '',
                }, {
                    field: 'className',
                    label: '类名',
                    show: true,
                    width: '',
                }, {
                    field: 'methodName',
                    label: '方法名',
                    show: true,
                    width: '',
                }, {
                    field: 'lineNum',
                    label: '行数',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '请求时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: []
                }
            }
        },
        mounted() {
            PubSub.subscribe("refreshErrorLog",() => {
                this.$refs.table.getData();
            });
        }
    }
</script>

<style scoped>

</style>
